import { Button, Modal } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { MdWarning } from "react-icons/md";

function ComponentModalErrorSever({show, handleClose, error}){
    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Body className="position-relative overflow-hidden">
                <h5><MdWarning className="text-danger"/></h5>
                <ul className="list-unstyled">
                    <li>
                        <p>
                            {
                                error?.data.error?.message
                            }
                        </p>
                    </li>
                </ul>

                <div className="text-right">
                    <Button variant="light" onClick={handleClose}>Aceptar</Button>
                </div>
            </Modal.Body>
        </Modal>
    )

}

export default withTranslation()(ComponentModalErrorSever)